<div
  class="d-inline-block"
  #dropdown="ngbDropdown"
  ngbDropdown
  autoClose="outside"
>
  <button
    class="btn btn-primary btn-sm dropdown-toggle hide-arrow"
    ngbDropdownToggle
  >
    Filters <span data-feather="filter" class="ml-25"></span>
  </button>

  <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
    <!-- EMPLOYEES -->
    <li *ngIf="employees.length > 0">
      <a class="dropdown-item">Employees</a>
      <ul
        class="dropdown-menu dropdown-submenu scrollable pt-0 dropdown-submenu-left"
        style="width: 300px"
      >
        <li class="px-50 sticky-search border-bottom">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search"
            [(ngModel)]="employeeFilter"
          />
        </li>

        <li
          *ngFor="
            let emp of employees | filter : employeeFilter : employeeFilterKeys
          "
        >
          <a class="dropdown-item" (click)="selectEmployee(emp)">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                class="custom-control-input"
                [checked]="selectedEmployeeId === emp.id"
                [id]="'emp' + emp.id"
              />
              <label
                class="custom-control-label m-0"
                [for]="'emp' + emp.id"
              ></label>
            </div>
            <div class="d-flex flex-nowrap">
              <span class="my-des alt"
                >{{ emp.firstName }} ({{ emp.userName }})</span
              >
            </div>
          </a>
        </li>
      </ul>
    </li>

    <!-- MODULES -->
    <li>
      <a class="dropdown-item">Modules</a>
      <ul
        class="dropdown-menu dropdown-submenu scrollable pt-0 dropdown-submenu-left"
        style="width: 300px"
      >
        <li class="px-50 sticky-search border-bottom">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search"
            [(ngModel)]="moduleFilter"
          />
        </li>

        <li
          *ngFor="let mod of modules | filter : moduleFilter : moduleFilterKeys"
        >
          <a class="dropdown-item" (click)="selectModule(mod)">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                class="custom-control-input"
                [checked]="selectedModuleId === mod.id"
                [id]="'mod' + mod.id"
              />
              <label
                class="custom-control-label m-0"
                [for]="'mod' + mod.id"
              ></label>
            </div>
            <div class="d-flex flex-nowrap">
              <span class="my-des alt">{{ mod.title }}</span>
            </div>
          </a>
        </li>
      </ul>
    </li>

    <!-- FEATURES -->
    <li>
      <a class="dropdown-item">Features</a>
      <ul
        class="dropdown-menu dropdown-submenu scrollable pt-0 dropdown-submenu-left"
        style="width: 260px"
      >
        <li class="px-50 sticky-search border-bottom">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search"
            [(ngModel)]="featureFilter"
          />
        </li>

        <li
          *ngFor="
            let feat of features | filter : featureFilter : featureFilterKeys
          "
        >
          <a class="dropdown-item" (click)="selectFeature(feat)">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                class="custom-control-input"
                [checked]="selectedFeatureId === feat.id"
                [id]="'feat' + feat.id"
              />
              <label
                class="custom-control-label m-0"
                [for]="'feat' + feat.id"
              ></label>
            </div>
            <div class="d-flex flex-nowrap">
              <span class="my-des alt">{{ feat.title }}</span>
            </div>
          </a>
        </li>
      </ul>
    </li>

    <!-- PROJECTS -->
    <li *ngIf="projects.length">
      <a class="dropdown-item">Projects</a>
      <ul
        class="dropdown-menu dropdown-submenu scrollable pt-0 dropdown-submenu-left"
        style="width: 260px"
      >
        <li class="px-50 sticky-search border-bottom">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Search"
            [(ngModel)]="projectFilter"
          />
        </li>

        <li
          *ngFor="
            let project of projects | filter : projectFilter : projectFilterKeys
          "
        >
          <a class="dropdown-item" (click)="selectProject(project)">
            <div class="custom-control custom-radio">
              <input
                type="radio"
                class="custom-control-input"
                [checked]="selectedProjectId === project.id"
                [id]="'proj' + project.id"
              />
              <label
                class="custom-control-label m-0"
                [for]="'proj' + project.id"
              ></label>
            </div>
            <div class="d-flex flex-nowrap">
              <span class="my-des alt">{{ project.title }}</span>
            </div>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</div>
